import * as React from 'react';

import { AnswerQuestionsButtonContainer } from './AnswerQuestionsButtonContainer';
import { NewSearchButtonContainer } from './NewSearchButtonContainer';
import { SendMoreButtonContainer } from './SendMoreButtonContainer';
import { ShowAllButtonContainer } from './ShowAllButtonContainer';
import { StopSearchButtonContainer } from './StopSearchButtonContainer';
import { TunePeriodicityButtonContainer } from './TunePeriodicityButtonContainer';
import { ChatbotButtonsLayout } from '../../components/ChatbotButtonsLayout';
import { EChatbotButtons, useChatbotButtons } from '../../hooks/useChatbotButtons';

const CHATBOT_BUTTONS: { [key in EChatbotButtons]: React.ReactNode } = {
  [EChatbotButtons.AnswerQuestions]: <AnswerQuestionsButtonContainer key={EChatbotButtons.AnswerQuestions} />,
  [EChatbotButtons.ShowAll]: <ShowAllButtonContainer key={EChatbotButtons.ShowAll} />,
  [EChatbotButtons.NewSearch]: <NewSearchButtonContainer key={EChatbotButtons.NewSearch} />,
  [EChatbotButtons.StopSearch]: <StopSearchButtonContainer key={EChatbotButtons.StopSearch} />,
  [EChatbotButtons.TunePeriodicity]: <TunePeriodicityButtonContainer key={EChatbotButtons.TunePeriodicity} />,
  [EChatbotButtons.SendMore]: <SendMoreButtonContainer key={EChatbotButtons.SendMore} />,
};

export const ChatbotButtonsContainer: React.FC = () => {
  const buttons = useChatbotButtons();

  if (!buttons.length) {
    return null;
  }

  return <ChatbotButtonsLayout>{buttons.map(button => CHATBOT_BUTTONS[button])}</ChatbotButtonsLayout>;
};
